export const listData = [
  {
    name: "Propliners reality",
    link: "https://propliners.in/",
    description:
      "Propliners reality takes complete care of their investors and buyers as we are taking the properties for their own selves thus they take care of all aspects related to the properties like legal-check, proper documentation as per the local authority norms and most important guaranteed best price/rentals. They are working in this industry from long time hence most of their developers are well known to us hence we have the largest and updated property portfolio for all your real estate needs.",
    legal_name: "",
    headquarter: "Noida, Uttar Pradesh, India",
    business_model: "B2B",
    founding_date: "2018",
    employee_count: "10",
    team_member: [
      {
        name: "Achal Agarwal",
        designation: "Founder",
        profile_link: "https://www.linkedin.com/in/achal-agarwal-411a4037/",
      },
      {
        name: "Himanshu Propliners",
        designation: "Co-Founder",
        profile_link:
          "https://www.linkedin.com/in/himanshu-propliners-realty-noida/",
      },
    ],
    revenue_stream:
      "Advertising, Affiliate Marketing, E-commerce - Service, Lending",
    client_segment:
      "Administrative Services,  Consumer,  Services,  Media,  E-Commerce",
    target_companies: "Small Enterprise",
    target_geography: "India",
    user_age: "",
    user_income: "",
    user_location: "",
  },

  {
    name: "rentNet",
    link: "https://rentnet.in/",
    description:
      "rentNet: Free Property Management & Maintenance Software for 5 Properties. Simplify Real Estate Management using the best application. Collect Rent and Manage Properties with Ease!",
    legal_name: "",
    headquarter: "Bangalore, Karnataka, India",
    business_model: "B2B",
    founding_date: "2023",
    employee_count: "21 to 40",
    team_member: [
      {
        name: "Nikhil Adiga",
        designation: "Founder",
        profile_link: "https://www.linkedin.com/in/nikhil-adiga-253503176/",
      },
    ],
    revenue_stream: "Fee-For-Service",
    client_segment: "Real Estate  ",
    target_companies:
      "Startup,  Small Enterprise,  Medium Enterprise,  Large Enterprise  ",
    target_geography: "India,  Global ",
    user_age: "",
    user_income: "",
    user_location: "",
  },

  {
    name: "Piscis Networks",
    link: "https://piscisnetworks.com/",
    description:
      "Piscis Networks is an India-based OEM company that provides an SD-WAN solution to organizations of all sizes. Their SD-WAN solution is designed to help organizations improve their network performance, reliability, and security while reducing costs. Piscis Networks' SD-WAN solution is designed to be easy to deploy and manage, and it can be integrated with existing network infrastructure. The company also offers a range of professional services, including network assessment, design, and deployment, to help organizations get the most out of their SD-WAN investment. Overall, Piscis Networks is a reputable vendor that offers a comprehensive SD-WAN solution that can help organizations improve their network performance, reliability, and security.",
    legal_name: "Piscis Networks Private Limited",
    headquarter: "Mumbai, Maharashtra , India",
    business_model: "B2B",
    founding_date: "2021",
    employee_count: "<10",
    team_member: [
      {
        name: "Mandar Lokegaonkar",
        designation: "Founder & Director",
        profile_link: "https://www.linkedin.com/in/mandar-lokegaonkar/",
      },
    ],
    revenue_stream: "Licensing",
    client_segment:
      "E-Commerce,  Government & Military,  HealthTech / MedTech / Healthcare,  Logistics  ",
    target_companies:
      "Startup,  Small Enterprise,  Medium Enterprise,  Large Enterprise",
    target_geography: "Global ",
    user_age: "",
    user_income: "",
    user_location: "",
  },

  {
    name: "ORBITX INDIA AEROSPACE",
    link: "https://www.orbitx.in/",
    description:
      "Jaipur based, ORBITX INDIA AEROSPACE is developing reusable launch vehicle 'Atal-Yaan' to make space access more accessible and commercialize space travel.",
    legal_name: "ORBITX INDIA AEROSPACE PVT LTD",
    headquarter: "Jaipur, Rajasthan, India",
    business_model: "",
    founding_date: "2020",
    employee_count: "61 to 100",
    team_member: [
      {
        name: "Diraja Singh",
        designation: "Director",
        profile_link: "",
      },
      {
        name: "Pankaj Singh",
        designation: "Director",
        profile_link: "",
      },
    ],
    revenue_stream: "",
    client_segment: "",
    target_companies: "",
    target_geography: "",
    user_age: "",
    user_income: "",
    user_location: "",
  },

  {
    name: "Aone Packers And Movers",
    link: "https://aonepacker.com/",
    description:
      "Aone Packers And Movers are one of the best Packers and Movers in Gurgaon. Their team of highly proficient and experienced professional packers and movers in Gurgaon. Their team of experts acknowledges the importance of your belongings and takes every measure to ensure that they are safely packed, loaded, and transported to your new destination.",
    legal_name: "",
    headquarter: "Gurgaon, Haryana, India",
    business_model: "B2C",
    founding_date: "1980",
    employee_count: "11 to 20",
    team_member: [
      {
        name: "SHUBHAM PATEL",
        designation: "Founder",
        profile_link: "",
      },
      {
        name: "Pankaj Singh",
        designation: "Director",
        profile_link: "",
      },
    ],
    revenue_stream: "",
    client_segment: "Logistics",
    target_companies: "Medium Enterprise  ",
    target_geography: "India ",
    user_age: "18 to 25  ",
    user_income: "Lower-middle Income",
    user_location: "India",
  },

  {
    name: "Halfsquare Inc",
    link: "https://halfsquare.io/",
    description:
      "HalfSquare Inc an innovative cyber security and data security company, providing top-notch services to our clients. We specialize in preventing the unauthorized access of data by defending networks, systems, and database from cyber-attacks and vulnerabilities. We keep our clients data protected using the latest technologies, such as AI-driven dataprotection, Encryption, and Next-Generation Firewalls. Our experienced professionals provide custom solutions customized to the needs of each individual customer. As a team, we strive hard to make sure that each of our customers is provided with superior cybersecurity tailored to their specific circumstances.",
    legal_name: "",
    headquarter: "New York, New York, United States of America",
    business_model: "B2B",
    founding_date: "1st Jan 2022",
    employee_count: "151 to 250",
    team_member: [
      {
        name: "Rahul Vinodkumar Dadhich",
        designation: "Founder and CEO",
        profile_link: "https://www.linkedin.com/in/yesiamdadhich/",
      },
    ],
    revenue_stream: "Subscription, Fee-For-Service",
    client_segment: "",
    target_companies: "",
    target_geography: "",
    user_age: "",
    user_income: "",
    user_location: "",
  },

  {
    name: "Aeroin SpaceTech",
    link: "https://www.spaceaero.in/",
    description:
      "Aeroin SpaceTech is an “Aerospace Research Startup”.This establishment deals with all the projects related to Space Science and Technology. The main motto is to connect the world through SpaceTech. Aeroin focuses on building advanced Space Technology. It essentially consists of a collaboration that takes part in projects, research articles, and patent publications together. Aeroin currently working on Electric Propulsion System for Cubesat , Sounding rocket and dealing with the STEM engagement program. This collaboration mainly focuses to develop a brilliant and the most innovative space sector in INDIA itself. They are ready to collaborate with all SpaceTech companies. Lets fly to Space They not only build but also teach.",
    legal_name: "Aeroin SpaceTech Pvt. Ltd",
    headquarter: "Krishnagiri, Tamil Nadu, India",
    business_model: "B2B, B2C",
    founding_date: "2022",
    employee_count: "<10",
    team_member: [
      {
        name: "MS Ragul",
        designation: "Founder & CEO",
        profile_link: "https://www.linkedin.com/in/ragulms/",
      },
    ],
    revenue_stream: "Other",
    client_segment:
      "Aerospace & Defense,  Collaboration,  DeepTech,  SpaceTech  ",
    target_companies: "Startup",
    target_geography: "India",
    user_age: "26 to 34",
    user_income: "Lower-middle Income  ",
    user_location: "India",
  },

  {
    name: "Wavetech Telecom",
    link: "https://www.wavetechtelecoms.com/",
    description:
      "Wavetech Telecom Pvt Ltd. takes pleasure in introducing itself as a prominent Manufacturer, Exporter, Importer, Supplier and Service Provider of the market for the comprehensive range of Products such as RF Telecom microwave & Optical components With a vision to provide world-class products such as all types of RF components for CDMA, WCDMA, 2G, 3G, 4G, 5G & WIFI. Apart from products, they are also known for offering End to End In Building Solutions, WIFI solutions for Indoor & Outdoor Spaces, they also take Annual Maintenance Contracts/Sub Contracts for our offered products; therefore, you get all solutions under one roof and at the most competitive prices. They are pleased to inform you that the company's phenomenal success is related to the fact that the organization operates in a customer-centric manner by supplying innovative, cost-effective & suitable technical solutions of superior quality with zero defects in the shortest possible time.",
    legal_name: "Wavetech Telecom Private Limited",
    headquarter: "Bengaluru, Karnataka, India",
    business_model: "B2B",
    founding_date: "2012",
    employee_count: "21 to 40",
    team_member: [
      {
        name: "Srinivas Raju Chinda",
        designation: "Founder & Managing Director",
        profile_link:
          "https://www.linkedin.com/in/chinda-srinivas-raju-45138422/",
      },
    ],
    revenue_stream: "Fee-For-Service",
    client_segment: "Medium Enterprise  ",
    target_companies: "India,  Asia Pacific  ",
    target_geography: "India",
    user_age: "26 to 34,  35 to 45,  46 to 60 ",
    user_income: "Lower-middle Income,  Upper-middle Income,  High Income  ",
    user_location: "India,  Asia Pacific  ",
  },

  {
    name: "Astranis",
    link: "https://www.astranis.com/",
    description:
      "Astranis is a developer of a new satellite technology that aims to transmit data down to specific terrestrial locations with each satellite it launches. The company's mission is to help get online the 4 billion people who are without internet access. It was founded in 2015 and is headquartered in San Francisco, California.",
    legal_name: "",
    headquarter: "San Francisco, California, United States",
    business_model: "",
    founding_date: "2015",
    employee_count: "251 to 500",
    team_member: [
      {
        name: "Ryan McLinko",
        designation: "Co-Founder",
        profile_link: "https://www.linkedin.com/in/mclinkor/",
      },
      {
        name: "John Gedmark",
        designation: "Co-Founder & CEO",
        profile_link: "https://www.linkedin.com/in/johngedmark/",
      },
    ],
    revenue_stream: "",
    client_segment: "",
    target_companies: "",
    target_geography: "",
    user_age: "",
    user_income: "",
    user_location: "",
  },

  {
    name: "Nile",
    link: "https://nilesecure.com/enterprise-network/security/",
    description:
      "Nile understand that to take care of their customers, they must take care of their team members. To be the best company, they must be their best selves. Every team member has a voice at Nile, one that is always valued, respected, and appreciated. These values define each of them and all of them, with innovation at the center of all they do.",
    legal_name: "Nile Secure",
    headquarter: "San Jose, California, United States of America",
    business_model: "B2C",
    founding_date: "2020",
    employee_count: "<10",
    team_member: [
      {
        name: "Ali Burhan",
        designation: "",
        profile_link: "https://www.linkedin.com/in/abratul/",
      },
    ],
    revenue_stream:
      "Advertising, E-commerce - Service, Commission on transaction, E-commerce - Product",
    client_segment: "",
    target_companies: "",
    target_geography: "",
    user_age: "26 to 34,  More than 60",
    user_income: "Lower-middle Income,  Upper-middle Income  ",
    user_location: "Global,  North America,  South America  ",
  },
];
